/** */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import CampaignModule from './campaigns/_index';
import ContactModule from './contacts/_index';
import MailingListModule from './mailing-lists/_index';
import IntegrationsModule from './integrations/_index';
import SettingsModule from './settings/_index';
import TransactionalModule from './transactionals/_index';
import MemberAreaHeader from './header/header';
import GMDashboard from './dashboard';
import useScreenSize from 'hooks/size';
import UsersModule from './users/_index';
import { PermissionsContext } from 'contexts/permissions';
import { TutorialModule } from './tutorials/_index';
import { BubbleDisplayProvider } from 'contexts/bubble';
import { BubbleDisplay } from 'app/shared/bubble-display';
import { AppInsightModule } from './insights/app';
import { SMSModule } from './messaging/sms';
import { MobilePushModule } from './messaging/mobile';
import { WebPushModule } from './messaging/web';
import { WorkflowModule } from './automation/workflows';
import { NeuronModule } from './automation/neurons';
import { EventModule } from './automation/event';
import { SenderIDModule } from './messaging/sender-id';
import { AIAssistantLauncher } from './ai-assistant/launcher';
// import { WhatsAppModule } from './messaging/whatsapp';

export const ModuleLayout = ({ setOpenMenuTray }) => {
  const { permissions } = useContext(PermissionsContext);
  const { user_management } = useSelector((state) => state.flags);
  const { isDesktop, isMiniDesktop } = useScreenSize();

  return (
    <BubbleDisplayProvider>
      <section className="app-content">
        <>
          <MemberAreaHeader onHamburgerClick={() => setOpenMenuTray(true)} />
          <Routes>
            <Route path="insights/app/*" element={<AppInsightModule />} />
            {permissions['campaign:view'] && (
              <Route path="campaigns/*" element={<CampaignModule />} />
            )}
            {permissions['automation:view'] && (isMiniDesktop || isDesktop) && (
              <Route path="workflows/*" element={<WorkflowModule />} />
            )}
            {permissions['automation:view'] && (isMiniDesktop || isDesktop) && (
              <Route path="neurons/*" element={<NeuronModule />} />
            )}
            {permissions['automation:view'] && (isMiniDesktop || isDesktop) && (
              <Route path="triggers/*" element={<EventModule />} />
            )}
            {permissions['audience:view'] && (
              <Route path="audiences/*" element={<MailingListModule />} />
            )}
            {permissions['contact:view'] && <Route path="contacts/*" element={<ContactModule />} />}
            {permissions['integration:view'] && (
              <Route path="integrations/*" element={<IntegrationsModule />} />
            )}
            <Route path="settings/*" element={<SettingsModule />} />
            <Route path="sender-ids/*" element={<SenderIDModule />} />
            <Route path="sms/*" element={<SMSModule />} />
            <Route path="mobile/*" element={<MobilePushModule />} />
            <Route path="web/*" element={<WebPushModule />} />
            {/* <Route path="whatsapp/*" element={<WhatsAppModule />} /> */}
            <Route path="transactionals/*" element={<TransactionalModule />} />
            <Route path="tutorials/*" element={<TutorialModule />} />
            {user_management?.is_permitted && <Route path="users/*" element={<UsersModule />} />}
            <Route path="/*" element={<GMDashboard />} />
          </Routes>
        </>
      </section>
      <BubbleDisplay />
      <AIAssistantLauncher />
    </BubbleDisplayProvider>
  );
};
